/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/**
@format
@flow
*/

import React, { useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import {
  useDispatch, useSelector, shallowEqual,
} from 'react-redux';
import { Helmet } from 'react-helmet-async';
import ActionTypes from '@ziynx/action-types';
import { useLocation } from 'react-router-dom';
import { eventNames } from '@ziynx/analytics';
import {
  withAppManager, useNotification, LoadingSpinner, formatDate,
} from '@ziynx/components/utilities';
import { Heading, Body } from '@ziynx/components/typography';
// import { Button, ButtonPillGroup } from '@ziynx/components/buttons';
import Headline from '@ziynx/components/headlines';
import Icon from '@ziynx/components/icons';
import Link from '@ziynx/components/links';
import Card from '@ziynx/components/cards';
import { ContentContainer, PageTemplate } from '@ziynx/components/layout';
import Colors from '@ziynx/theme/colors';
import type { ManagedProps } from '@ziynx/flow-types/appManager';
import type { Viewports } from '@ziynx/flow-types/globals';
import DestructiveModal from '../Modals/DestructiveModal';

type Props = $ReadOnly<{|
  viewport: Viewports,
  /**
   * Navigation stack
   */
  history: Object,
|}>;

type DispatchAction = {
  type: string,
} => void;

type Location = {
  state: {
    from: string,
  }
};

const QuestionsWrapper = styled.div`
  ${({ isDesktop }) => isDesktop && 'margin-top: 40px;'}
`;

const StyledHeadline = styled(Headline)`
  margin-bottom: 40px;
`;

// const StyledButtonPillWrapper = styled.div`
//   display: flex;
//   padding-top: 24px;
//   padding-bottom: 40px;
//   position: relative;
//   ${({ isMobile }) => (isMobile
//     ? 'overflow-x: scroll; overflow-y: hidden; white-space: nowrap;}'
//     : 'flex-wrap: wrap;')
// }
//   &::-webkit-scrollbar { width: 0; background: transparent; display: none;}
//   ${({ isMobile, viewport }) => isMobile && (viewport === 'mobileSmall' ? 'margin-left: -16px; margin-right -16px;' : 'margin-left: -3.8%; margin-right: -3.8%;')}
// `;

// const PillWrapper = styled.div`
//   margin-right: 16px;
//   overflow: visible;
//   ${({ isMobile, firstChild, viewport }) => isMobile && firstChild && `margin-left: ${viewport === 'mobileSmall' ? '16px' : '3.8%'};`}
//   ${({ isMobile, lastChild, viewport }) => isMobile && lastChild && `margin-right: 0; padding-right: ${viewport === 'mobileSmall' ? '16px' : '3.8%'};`}
// `;

const StyledCard = styled(Card)`
  margin-bottom: 24px;
`;

const EmptyWrapper = styled.div`
  text-align: center;
`;

const IconWrapper = styled.div`
  margin-bottom: 16px;
`;

const TextWrapper = styled.div`
  margin-bottom: 4px;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-top: 32px;
`;

const ContentScreen = (props: ManagedProps<Props>): React$Node => {
  const { viewport, history } = props;
  const dispatch: DispatchAction = useDispatch();
  const location: Location = useLocation();
  const { notificationDispatch } = useNotification();
  const isMobileSmall = viewport === 'mobileSmall';
  // const isMobile = viewport === 'mobileSmall' || viewport === 'mobile';
  const statementService = useSelector(({ statements }) => statements || {}, shallowEqual);

  // FOR ARCHIVE FEATURE
  const [statementId, setStatementId] = useState();
  const statementItemService = useSelector(
    ({ statementItem }) => statementItem[statementId] || {}, shallowEqual,
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setmodalType] = useState('archive');

  // FILTERING
  // const [filteredContent, setFilteredContent] = useState();
  // const [activeFilter, setActiveFilter] = useState('allStatements');
  // const [filterQty, setFilterQty] = useState({
  //   allStatements: statementService?.results?.filter((item) => !item?.archived),
  //   videoStatements: statementService?.results?.filter((item) => !item?.archived || item?.variant === 'video'),
  //   textStatements: statementService?.results?.filter((item) => !item?.archived || item?.variant === 'statement'),
  //   archived: statementService?.results?.filter((item) => item?.archived),
  // });

  const dispatchGet = useCallback(() => {
    // enter page with cleared reducer.
    dispatch({
      type: ActionTypes.statements.getAll.START,
      id: 'me',
    });
  }, []);

  const resetNotification = () => {
    setTimeout(() => {
      dispatch({
        type: ActionTypes.statementItem.clear,
      });
    }, 5000);
  };

  useEffect(() => {
    dispatchGet();
  }, []);

  // useEffect(() => {
  //   dispatch({
  //     type: ActionTypes.statementItem.clear,
  //   });
  //   const allStatements = statementService?.results?.filter((item) => !item?.archived);
  //   const videoStatements = allStatements?.filter((item) => item?.variant === 'video');
  //   const textStatements = allStatements?.filter((item) => item?.variant === 'statements');
  //   const archived = statementService?.results?.filter((item) => item?.archived === true);
  //   setFilterQty({
  //     allStatements: allStatements?.length,
  //     videoStatements: videoStatements?.length,
  //     textStatements: textStatements?.length,
  //     archived: archived?.length,
  //   });
  //   if (activeFilter === 'allStatements') {
  //     setFilteredContent(allStatements || []);
  //   }
  //   if (activeFilter === 'videoStatements') {
  //     setFilteredContent(videoStatements || []);
  //   }
  //   if (activeFilter === 'textStatements') {
  //     setFilteredContent(textStatements || []);
  //   }
  //   if (activeFilter === 'archived') {
  //     setFilteredContent(archived || []);
  //   }
  // }, [statementService?.results, activeFilter]);

  // FOR ARCHIVE FEATURE
  useEffect(() => {
    if (statementItemService?.success && !statementItemService?.fetching) {
      dispatchGet();
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'success',
          content: `Content has been ${modalType}d successfully.`,
        },
      });
      resetNotification();
    }
    if (statementItemService?.error && !statementItemService?.fetching) {
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'error',
          content: 'Something went wrong. Please try again.',
        },
      });
      resetNotification();
    }
  }, [statementId, statementItemService?.success, statementItemService?.error]);

  useEffect(() => {
    if (location?.state?.from === '/content/video-question') {
      const notice = statementService?.patchedQuestion ? 'edited' : 'created';
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'success',
          content: `Video question was successfully ${notice}.`,
        },
      });
      dispatch({ type: ActionTypes.statements.clear });
      history.replace();
    }
  }, [location?.state?.from]);

  useEffect(() => {
    if (location?.state?.from === '/content/video-question') {
      dispatch({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.navigated_content,
        properties: {
          referrer: location?.state?.from,
        },
      });
    } else {
      dispatch({
        type: ActionTypes.analytics.logEvent.START,
        name: eventNames.navigated_content,
      });
    }
  }, [location?.state?.from]);

  useEffect(() => {
    if (statementService?.removalSuccess && !statementService?.removing) {
      dispatchGet();
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'success',
          content: 'Content has been removed successfully.',
        },
      });
    }
    if (statementService?.removalError && !statementService?.removing) {
      notificationDispatch({
        type: ActionTypes.notifications.add.START,
        payload: {
          variant: 'error',
          content: 'Something went wrong. Please try again.',
        },
      });
    }
  }, [statementService?.removing, statementService?.removalSuccess, statementService?.removalError]);

  const renderEmpty = () => (
    <EmptyWrapper>
      <IconWrapper>
        <Icon name="info-fill" small color={Colors.GrayLight} />
      </IconWrapper>
      <TextWrapper>
        <Heading medium color={Colors.Gray}>No questions</Heading>
      </TextWrapper>
      {!(statementService?.results ?? []).length
      && (
        <Body medium>
          <Link variant="text" onClick={() => history.push('/content/video-question', { from: 'Content' })} large>Add new</Link>
        </Body>
      )}
    </EmptyWrapper>
  );

  // FOR ARCHIVE FEATURE

  const clickArchiveLink = (id, fn) => {
    if (id !== statementId) {
      setStatementId(id);
    }
    setmodalType(fn);
    setModalOpen(true);
  };

  const archiveQuestion = (id) => {
    dispatch({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.archived_question,
    });
    dispatch({
      type: ActionTypes.statementItem.patchQuestion.START,
      body: [{
        op: 'replace',
        path: 'archived',
        value: true,
      }],
      id,
    });
    // setFilteredContent((prevContent) => prevContent.filter((item) => item?.id !== id));
    setModalOpen(false);
  };

  const unarchiveQuestion = (id) => {
    dispatch({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.unarchived_question,
    });
    dispatch({
      type: ActionTypes.statementItem.patchQuestion.START,
      body: [{
        op: 'remove',
        path: 'archived',
      }],
      id,
    });
    // setFilteredContent((prevContent) => prevContent.filter((item) => item?.id !== id));
    setModalOpen(false);
  };

  const clickDeleteLink = (id) => {
    if (id !== statementId) {
      setStatementId(id);
    }
    setmodalType('delete');
    setModalOpen(true);
  };

  const deleteQuestion = (questionId) => {
    dispatch({
      type: ActionTypes.analytics.logEvent.START,
      name: eventNames.deleted_question_content,
      properties: { questionId },
    });
    dispatch({
      type: ActionTypes.statements.removeQuestion.START,
      id: questionId,
    });
    setModalOpen(false);
    // setFilteredContent((prevStatement) => prevStatement.filter((item) => item.id !== questionId));
  };

  const _renderQuestion = () => statementService?.results?.map((item, index) => {
    if (!item) return null;
    if (!item?.title && !item?.question) return null;

    const editQuestionPath = '/content/video-question/';
    const questionUrl = editQuestionPath.concat(item?._id);
    // eslint-disable-next-line prefer-template
    const postDate = 'Posted ' + formatDate(item?.createdAt);

    const replyUrl = editQuestionPath.concat(item?._id, '/replies');
    const numReplies = item?.responses ?? 0;
    // eslint-disable-next-line prefer-template
    const replyString = numReplies + (numReplies === 1 ? ' reply' : ' replies');

    const numRecentReplies = item?.recentResponses ?? 0;
    // eslint-disable-next-line prefer-template
    const recentReplyString = '(' + numRecentReplies + ' new today)';

    return (
      <StyledCard
        key={index}
        variant="squircle"
        squircle={{
          iconName: 'play-circle',
          color: Colors.White,
          backgroundColor: Colors.GrayVeryDark,
          inverted: false,
        }}
        rightAction={{
          popover: {
            position: 'bottomLeft',
            links: [
              {
                children: numReplies > 0 ? 'View replies' : undefined,
                onClick: () => history.push(replyUrl),
              },
              {
                children: 'Edit question',
                large: true,
                onClick: () => history.push(questionUrl, { from: 'content' }),
              },
              {
                children: item?.archived ? 'Unarchive question' : 'Archive question',
                large: true,
                color: Colors.SecondaryRed,
                onClick:
                item?.archived
                  ? (() => clickArchiveLink(item?._id, 'unarchive'))
                  : (() => clickArchiveLink(item?._id, 'archive')),
              },
              {
                children: 'Delete question',
                large: true,
                color: Colors.SecondaryRed,
                onClick: () => clickDeleteLink(item?._id),
              },
            ],
          },
        }}
        title={item?.question}
        subtitle={replyString}
        subtitleColor={Colors.GrayVeryDark}
        {...(numRecentReplies > 0 && { notificationText: recentReplyString })}
        body={postDate}
        archived={item?.archived}
        viewport={viewport}
      />
    );
  });

  // const onFilterButtonClick = (filterName: string) => {
  //   setActiveFilter(filterName);
  // };

  // const filterButtons = [
  //   {
  //     label: {
  //       text: `All content (${filterQty?.allStatements})`,
  //     },
  //     iconLeft: {
  //       name: 'content-type',
  //     },
  //     onClick: () => onFilterButtonClick('allStatements'),
  //     active: activeFilter === 'allStatements',
  //     activeConfig: {
  //       backgroundColor: Colors.PrimaryBlue,
  //       text: Colors.White,
  //       iconLeft: Colors.White,
  //     },
  //   },
  //   {
  //     label: {
  //       text: `Videos (${filterQty?.videoStatements})`,
  //     },
  //     iconLeft: {
  //       name: 'play-circle',
  //     },
  //     onClick: () => onFilterButtonClick('videoStatements'),
  //     active: activeFilter === 'videoStatements',
  //     activeConfig: {
  //       backgroundColor: Colors.PrimaryBlue,
  //       text: Colors.White,
  //       iconLeft: Colors.White,
  //     },
  //   },
  //   {
  //     label: {
  //       text: `Statements (${filterQty?.textStatements})`,
  //     },
  //     iconLeft: {
  //       name: 'comment',
  //     },
  //     onClick: () => onFilterButtonClick('textStatements'),
  //     active: activeFilter === 'textStatements',
  //     activeConfig: {
  //       backgroundColor: Colors.PrimaryBlue,
  //       text: Colors.White,
  //       iconLeft: Colors.White,
  //     },
  //   },
  //   {
  //     label: {
  //       text: `Archived (${filterQty?.archived})`,
  //     },
  //     iconLeft: {
  //       name: 'archive-fill',
  //     },
  //     onClick: () => onFilterButtonClick('archived'),
  //     active: activeFilter === 'archived',
  //     activeConfig: {
  //       backgroundColor: Colors.PrimaryBlue,
  //       text: Colors.White,
  //       iconLeft: Colors.White,
  //     },
  //   },
  // ];

  const leftSlot = (): React$Node => (
    <>
      <StyledHeadline
        variant="page"
        title={{ text: 'Content' }}
        squircleButton={isMobileSmall && {
          icon: { size: 'large' },
          onClick: () => history.push('/content/video-question'),
        }}
        textLink={!isMobileSmall && {
          large: true,
          children: 'Add new',
          onClick: () => history.push('/content/video-question'),
        }}
        // popover={!statementServiceLimit ? {
        //   trigger: !isMobileSmall ? <Link variant="text" type="subheading" large onClick={() => history.push('/content/video-question')}>Add new</Link> : null,
        //   links: [
        //     { children: 'Video question', onClick: () => history.push('/content/video-question') },
        //     {
        //       children: 'Statement question',
        //       // onClick: () => history.push(`/content/${companyService._id}/create-statement`)
        //     },
        //   ],
        // } : null}
      />
      {/* {viewport !== 'desktop'
      && (
        <StyledButtonPillWrapper viewport={viewport} isMobile={isMobile}>
          {filterButtons.map((pill, index) => (
            <PillWrapper
              key={`pill-${index}-${pill?.label?.text}`}
              isMobile={isMobile}
              viewport={viewport}
              firstChild={index === 0}
              lastChild={index === (filterButtons?.length - 1)}
            >
              <Button variant="pill" {...pill} />
            </PillWrapper>
          ))}
        </StyledButtonPillWrapper>
      )} */}
    </>
  );

  const _renderLeftContent = () => {
    if (!(statementService?.results ?? []).length
    && (!statementService?.fetching
    && statementService?.success)) {
      return <Card variant="list" renderEmpty={renderEmpty} />;
    }
    return _renderQuestion();
  };

  const leftContent = (): React$Node => (
    <QuestionsWrapper isDesktop={viewport === 'desktop'}>
      {_renderLeftContent()}
      {statementService?.fetching && !(statementService?.results ?? []).length && (
        <SpinnerWrapper>
          <LoadingSpinner />
        </SpinnerWrapper>
      )}
    </QuestionsWrapper>
  );

  const rightSlot = (): React$Node => (
    <>
      {/* <Headline
        variant="default"
        title={{ text: 'Filter' }}
        style={{ marginBottom: '24px' }}
      />
      <ButtonPillGroup stacked pills={filterButtons} /> */}
    </>
  );

  let modalBodyText = modalType === 'unarchive' ? 'This item will be displayed with all other content.' : 'The question will be displayed under "Archived".';
  let modalPrimaryButton = modalType === 'unarchive' ? 'Unarchive' : 'Archive';
  let modalOnClick = modalType === 'unarchive' ? () => unarchiveQuestion(statementId) : () => archiveQuestion(statementId);

  if (modalType === 'delete') {
    modalBodyText = 'This content will be deleted.';
    modalPrimaryButton = 'Delete';
    modalOnClick = () => deleteQuestion(statementId);
  }

  return (
    <>
      <Helmet>
        <title>Content | ZIYNX</title>
      </Helmet>
      <DestructiveModal
        open={modalOpen}
        heading={{
          text: `Are you sure you want to ${modalType} this content?`,
        }}
        body={{
          text: modalBodyText,
        }}
        buttonGroup={{
          destructive: {
            children: modalPrimaryButton,
            onClick: modalOnClick,
          },
          primary: {
            children: 'Cancel',
            onClick: () => setModalOpen(false),
          },
        }}
      />
      <ContentContainer offsetTop={86}>
        <PageTemplate
          alwaysShowRightSlot
          viewport={viewport}
          leftSlot={leftSlot()}
          leftContent={leftContent()}
          rightSlot={rightSlot()}
          headerOffset={-1000} // Temporary measure to remove barSticky
        />
      </ContentContainer>
    </>
  );
};

export default (withAppManager(ContentScreen): React$ComponentType<ManagedProps<Props>>);
